import {
  DELETE_TASK,
  SET_ADMINS,
  SET_CONTACTS,
  SET_LOADING,
  SET_TASKS,
  UPDATE_CONTACT,
  UPDATE_TASK,
} from './actions/callCenter'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const CallCenter = RepositoryFactory.get('callCenter')
const Users = RepositoryFactory.get('users')
const flag = true

export default {
  namespaced: true,
  state: {
    tasks: [],
    pagination: {},
    paginationCont: {},
    contacts: [],
    contact: {},
    admins: [],
    loading: false,
    loadingCont: false,
    loadingAdmin: false,
    loadingDelCT: false,
  },
  getters: {
    getList: state => (key, id) =>
      id ? state[key].find(i => i.id === id) : state[key],
    getPagination: state => type => state[`pagination${type || ''}`],
    getLoading: state => type => state[`loading${type || ''}`],
  },
  actions: {
    fetchTasks({ commit }, settings = {}) {
      commit(SET_LOADING, { flag })
      CallCenter.getTasksList(settings)
        .then(res => commit(SET_TASKS, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    fetchTask({ commit }, id) {
      const type = 'Task'

      commit(SET_LOADING, { flag, type })
      CallCenter.getTask(id)
        .then(res => commit(UPDATE_TASK, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    updateTask({ commit }, { id, data }) {
      commit(SET_LOADING, { flag })
      CallCenter.updateTask(id, data)
        .then(res => commit(UPDATE_TASK, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
    fetchAdmins({ commit }) {
      const type = 'Admin'

      commit(SET_LOADING, { flag, type })
      Users.getAdmins()
        .then(res => commit(SET_ADMINS, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    fetchContacts({ commit, dispatch }, settings = {}) {
      const type = 'Cont'

      commit(SET_LOADING, { flag, type })
      CallCenter.getContactsList(settings)
        .then(res => {
          const { data } = res

          if (settings.task_id && !data.items.length) {
            dispatch('fetchTask', settings.task_id)
          }
          commit(SET_CONTACTS, data)
        })
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    fetchContact({ commit }, id) {
      const type = 'Task'

      commit(SET_LOADING, { flag, type })
      CallCenter.getContact(id)
        .then(res => commit(UPDATE_CONTACT, res.data))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    deleteContFromTask({ commit, dispatch }, { settings = {}, contact_ids }) {
      const type = 'DelCT'

      commit(SET_LOADING, { flag, type })
      CallCenter.deleteContactFromTask(settings.task_id, contact_ids)
        .then(() => dispatch('fetchContacts', settings))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING, { type }))
    },
    deleteTask({ commit }, id) {
      commit(SET_LOADING, { flag })
      CallCenter.deleteTask(id)
        .then(() => commit(DELETE_TASK, id))
        .catch(e => console.log(e))
        .finally(() => commit(SET_LOADING))
    },
  },
  mutations: {
    [SET_LOADING](state, obj = {}) {
      const { flag, type } = obj

      state[`loading${type || ''}`] = Boolean(flag)
    },
    [SET_TASKS](state, data) {
      const { items, _meta } = data

      state.pagination = _meta
      state.tasks = items
    },
    [SET_ADMINS](state, data) {
      const { items } = data

      state.admins = items
    },
    [SET_CONTACTS](state, data) {
      const { items, _meta } = data

      state.paginationCont = _meta
      state.contacts = items
    },
    [UPDATE_TASK](state, data) {
      if (data) {
        const index = state.tasks.findIndex(f => f.id === data.id)

        if (index >= 0) {
          state.tasks.splice(index, 1, data)
        } else {
          state.tasks.push(data)
        }
      }
    },
    [UPDATE_CONTACT](state, data) {
      if (data) {
        const index = state.contacts.findIndex(f => f.id === data.id)

        if (index >= 0) {
          state.contacts.splice(index, 1, data)
        } else {
          state.contacts.push(data)
        }
      }
    },
    [DELETE_TASK](state, id) {
      state.tasks = state.tasks.filter(d => d.id !== id)
    },
  },
}
